import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-option-label',
  templateUrl: './form-option-label.component.html',
  styleUrls: ['./form-option-label.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormOptionLabelComponent {
  @Input() labelFor: string | null = null;
}
